var render = function render(){var _vm=this,_c=_vm._self._c;return _c('swiper',{ref:"swiper",staticClass:"category-rooms-swiper",attrs:{"options":_vm.swiperOption}},[_vm._l((_vm.previewRooms),function(room){return _c('swiper-slide',{key:room.id},[_c('Room',{attrs:{"room":room,"is-recently-visited":_vm.isRecentlyVisited}})],1)}),(_vm.isPromotedCategory)?_c('swiper-slide',[_c('RoomPromoteCard')],1):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }